import { render, staticRenderFns } from "./ClonarSolicitacaoAutoriz.vue?vue&type=template&id=bd318cb8&"
import script from "./ClonarSolicitacaoAutoriz.vue?vue&type=script&lang=js&"
export * from "./ClonarSolicitacaoAutoriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports